/* global jQuery */
/* global MicroModal */
import { Module } from "wrapper6";
import { debounce } from "../utils/_debounce";
import { ga_newsletter } from "../utils/_ga";
import { getCityByZip } from "../utils/_city-by-zip";
import { toggleClass, hasClass, removeClass, addClass } from "../utils/_class-handlers";
import { NewsletterController } from '../public/datastores/newsletterController'

var $ = jQuery;

export default class Newsletter extends Module {

	ready() {

        this.modalID = 'newsletter-modal';
        this.modal = document.getElementById(this.modalID);
        this.eventListeners();

        this.cityZipCode();
        this.submitMessage();
        
    }

    eventListeners() {
        let that = this;
        // Triggers
        $(document.body).on('click', '.open-newsletter', (e) => {
            e.preventDefault();
            this.openModal();
        });


        this.openevent = new Event('modalOpen');
        this.closeevent = new Event('modalClose');
        this.submitevent = new Event('modalSubmit');

        $(this.modal).on('submit', 'form', function(e){
           e.preventDefault();
            let form = $(e.target);
            let data = form.serializeForm();

            form.find('.submit-container p.message, .submit-container a.button.optin').remove();

            if(typeof data.INTERESTS === 'undefined'){
                alert('Du skal vælge  mindst ét interesseområde');
                return;
            }


           that.ajaxSignup(data, jQuery(this.modal).find('.submit-container'));
        });
        $('form.mc4wp-form-292').on('submit', function(e){
            e.preventDefault();
            let form = $(e.target);
            let data = form.serializeForm();

            form.find('.submit-container p.message, .submit-container a.button.optin').remove();

            if(typeof data.INTERESTS === 'undefined'){
                alert('Du skal vælge  mindst ét interesseområde');
                return;
            }

            that.ajaxSignup(data, form.find('.submit-container'));
        });
    }

    ajaxSignup(data,message_container) {
        let that = this;
        data.action = "modal_signup";

        $.ajax({
            method: 'POST',
            url: window.main_theme_objects.ajax_url,
            data: data,
        }).done((res) => that.ajaxSignupCallback.call(that,res,message_container) ).fail((res) => that.ajaxSignupCallback.call(that,res,message_container));
    }

    ajaxSignupCallback(res,message_container){
	    if(res.message && typeof res.show_link !== 'boolean' && res.show_link !== true){
	        alert(res.message);
        }else{
          let button = res.show_link === true ? '<a class="button optin" href="'+res.link+'" target="_blank">'+res.link_text+'</a>' : ''
          message_container.append('<p class="message" data-success="'+res.success.toString()+'">'+res.message+'</p>'+button);
      }
	    if(res.success){
            ga_newsletter(); // Send Analytics newsletter event
        NewsletterController.getInstance().success(res)
            this.closeModal();
        }
    }

    openModal() {
        if (this.modal){
            MicroModal.show(this.modalID,{disableScroll: true});
            this.modal.dispatchEvent(this.openevent);
        }
    }

    closeModal() {
        if (this.modal){
            MicroModal.close(this.modalID);
            this.modal.dispatchEvent(this.closeevent);
        }
    }

    cityZipCode() {

        const CITYWRAPPER_LOADER = document.querySelector('.input-wrapper.city');
        
        if (CITYWRAPPER_LOADER) {

            const ZIPCODE_INPUT = CITYWRAPPER_LOADER.querySelector('[name="ZIP"]');
            const CITY_INPUT = CITYWRAPPER_LOADER.querySelector('[name="CITY"]');

            ZIPCODE_INPUT.addEventListener('keyup', debounce(() => {

                addClass(CITYWRAPPER_LOADER, 'loading');

                getCityByZip( ZIPCODE_INPUT.value, (response) => {

                    if (response.success && typeof response.data.city != 'undefined' && response.data.city != '') {
                        CITY_INPUT.value = response.data.city;
                    }

                    removeClass(CITYWRAPPER_LOADER, 'loading');

                });
            }, 200));
        }
    }

    submitMessage() {

        const SUBMIT = document.querySelector('.mtt-newsletter [type="submit"]');
        const AGREE_TERMS = document.querySelector('.mtt-newsletter [name="AGREE_TO_TERMS"]');
        const ERROR_CONTAINER = document.querySelector('.mtt-newsletter .mc4wp-response');
        
        if (SUBMIT && AGREE_TERMS) {
            SUBMIT.addEventListener('click', () => {
                if (AGREE_TERMS.checked == false) {
                    ERROR_CONTAINER.innerHTML = '<div class="mc4wp-alert mc4wp-error"><p>Accepter venligst vores privatlivspolitik.</p></div>';
                    return;
                } else {
                    ERROR_CONTAINER.innerHTML = '';
                }
                this.modal.dispatchEvent(this.submitevent);
            });
        }
    }
}